import { DailyLogCode, Log, MandatoryLogInformation, MileageLossCode } from '@/types/logs'
import { ReportReasonsIds } from '@/types/logs'

export const getMandatoryFieldsForLog = (log: Log): MandatoryLogInformation[] => {
    const result = [MandatoryLogInformation.Code, MandatoryLogInformation.Route, MandatoryLogInformation.Description]
    const isMileageLossLog = log.code in MileageLossCode

    if (
        !isMileageLossLog &&
        (([DailyLogCode.CodeBlue, DailyLogCode.CodeRed, DailyLogCode.Incident] as string[]).includes(log.code) ||
            (log.codeTypeReasonInfo &&
                Object.values(ReportReasonsIds).flat().includes(log.codeTypeReasonInfo.reasonId)))
    ) {
        return [...result, MandatoryLogInformation.LocationFrom]
    }

    if (isMileageLossLog) {
        const isZeroMileage = !!log.isZeroMileage
        const info = [
            ...result,
            ...(!isZeroMileage ? [MandatoryLogInformation.LocationFrom, MandatoryLogInformation.LocationTo] : []),
        ]

        if (log.trip) {
            info.push(MandatoryLogInformation.Run, MandatoryLogInformation.Duty, MandatoryLogInformation.Fleet)
        } else {
            info.push(MandatoryLogInformation.Trip)
        }

        if (log.code === MileageLossCode.OD && log.codeTypeReasonInfo?.reasonId === 'OD021') {
            info.push(MandatoryLogInformation.ExtraInfo)
        }

        return info
    }

    return result
}
